import { useNavigate } from "react-router-dom"
import { Footer } from "../Footer"
import { Header } from "../Header"
import { HeroSection } from "../HeroSection"
import ReactWhatsapp from 'react-whatsapp';

export const WhatsAppChatbot = () => {

    const navigate = useNavigate()

    return (
        <>
            <Header active="Products" />
            <HeroSection />

            {/* ---------------------------------- */}

            <div className="row bgdotimg " id="LFMS">
                <div className="col-12 col-md-10 mx-auto py-4">
                    <h3 className="fw-bold colorcharchol text-center"> WhatsApp Chatbot</h3>

                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>
                <div className="col-12 col-md-10 mx-auto py-3 text-center">
                    <p>
                        <b>आर टी ओ ठाणे संवाद</b>   WhatsApp Chatbot is designed to provide users with quick and easy access to information and assistance related to driving license services. The chatbot guides users through the entire process, offering step-by-step instructions for both online and offline procedures. Whether it's applying for a new driving license, renewing an existing one, or understanding the necessary documents & the chatbot ensures a smooth and hassle-free experience by delivering accurate and up-to-date information in real-time.
                    </p>


                </div>
            </div>
            {/* <!--end of LFMS sopi--> */}


            <div className="row py-5 px-3" id="key">
                <div className="col-12 col-md-10 mx-auto py-1">
                    <h3 className="fw-bold colorcharchol text-center">KEY FEATURES</h3>

                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center  box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p> <b>	ISSUE OF LEARNERS LICENCE </b> </p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p> <b>CHANGE OF ADDRESS IN LL </b> </p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p> <b>ISSUE OF DUPLICATE DL </b> </p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p> <b>CHANGE OF ADDRESS IN DL </b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>ENDORSEMENT TO DRIVE HAZARDOUS MATERIAL </b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>CHANGE OF NAME IN DL </b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>RENEWAL OF CL  </b></p>
                    </div>
                </div>

                <div className="col-10 col-md-4 mx-auto text-center box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto">
                        <img src="Assets/Images/correct.gif" alt="..." style={{ width: '40px' }} />
                        <p><b>RENEWAL OF DL  </b></p>
                    </div>
                </div>



            </div>
            {/* <!--end of row key features--> */}
            <div className="row py-5 px-3" id="key">
                <div className="col-12 col-md-10 mx-auto py-1">
                    <h3 className="fw-bold colorcharchol text-center">Business Information</h3>

                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>

                <div className="col-10 col-md-8 mx-auto   box-sn mt-4">
                    <div className="flex-grow-1 ms-3 m-auto pt-5">
                        <div className="row">
                            <div className="col-3">
                                <b>Business Name :</b>
                            </div>
                            <div className="col-9">
                                <p>  Center for Development of Advanced Technology, Pune</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <b>Physical Address : </b>
                            </div>
                            <div className="col-9">
                                <p>  103-104, A2, Omkar Nandan, Navale Bridge, Opp.Navale IT Park, Vadgaon Bk. Pune-411041, Maharashtra, India.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-3">
                                <b>Contact Info : </b>
                            </div>
                            <div className="col-9">
                                <p className="cursor-pointer text-primary"
                                    target="_blank"
                                    onClick={() => window.open('https://cdat.co.in/ContactPage?ScreenName=Contact')}>
                                    <b className="text-decoration">Click to Contact Us </b>
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div className="col-12 text-center mb-5">
                <button className="mx-2 btn btn-success" type='button'
                    onClick={()=>window.open("https://wa.me/918369532705")} target="_blank">
                    <img src="Assets/Images/social/whatsapp.png" alt="" className="mx-2"/>
                    WhatsApp Chatbot
                </button>
            </div>

            {/* <ReactWhatsapp number="=+918369532705" message="Hi" /> */}


            <div className="col-12 col-md-10 mx-auto py-1 mb-5">
                <h3 className="fw-bold colorcharchol text-center">Policy</h3>

                <div className="zoom-in-out-box2 m-auto">
                    <hr />
                </div>
            </div>

            <div className="row col-lg-8 mx-auto box-sn py-5 mb-5 bg-white px-2">

                <div className="col-12 col-lg-4">
                    <div className="row cursor-pointer" target="_blank"
                        onClick={() => window.open('https://cdat.work/RTO_Thane_Whatsapp_Privacy_Policy.html')}>
                        <div className="col-2 text-primary">
                            <i class="fa-solid fa-shield-halved"></i>
                        </div>
                        <div className="col-10 link_hover">
                            <span className="text-decoration">Privacy Policy </span>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-4">
                    <div className="row cursor-pointer" target="_blank"
                        onClick={() => window.open('https://cdat.work/RTO_Thane_Terms_Services_Policy.html')}>
                        <div className="col-2 text-primary">
                            <i class="fa-solid fa-shield-halved"></i>
                        </div>
                        <div className="col-10 link_hover">
                            <span className="text-decoration">Terms & Services </span>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-lg-4">
                    <div className="row cursor-pointer" target="_blank"
                        onClick={() => window.open('https://cdat.work/data_deletion.html')}>
                        <div className="col-2 text-primary">
                            <i class="fa-solid fa-shield-halved"></i>
                        </div>
                        <div className="col-10 link_hover">
                            <span className="text-decoration">Data Deletion Policy</span>
                        </div>
                    </div>
                </div>

            </div>

            {/* <div className="row" id="Brochure">
                <div className="col-12 charchole py-5">
                    <h4 className="text-center white">
                        <b>
                            "To acquire further information regarding the product."
                        </b>
                    </h4>

                    <p className="white  text-center py-3">
                        Explore the following details and specifications.
                    </p>

                    <div className="py-4 text-center">
                        <a
                            className="shrink-border text-decoration-none"
                            target="_blank">Explore Brochure</a>
                    </div>
                </div>
            </div> */}

            {/* <!--end of Brochure row--> */}




            <Footer />
        </>
    )
}